import { Message } from 'element-ui'

export default {
  install(Vue) {
    // v-paste=""
    Vue.directive('paste', {
      // eslint-disable-next-line no-unused-vars
      bind(el, binding, vnode) {
        el.addEventListener('paste', function(event) {
          if (!event.clipboardData) {
            Message({
              type: 'warning',
              message: '当前浏览器不支持粘贴',
            })
            return
          }
          if (
            event.clipboardData.items[0].type &&
            event.clipboardData.items[0].type.indexOf('image') > -1
          ) {
            //这里就是判断是否有粘贴进来的文件且文件为图片格式
            let file = event.clipboardData.items[0].getAsFile()
            let blobUrl
            if (file) {
              blobUrl = window.URL.createObjectURL(file)
            }
            file.blobUrl = blobUrl
            binding.value({ file, event })
          } else {
            Message({
              type: 'warning',
              message: '粘贴上传仅支持图片文件',
            })
          }
        })
      },
    })
  },
}
